import PremiumLanding from "@/components/PremiumLanding";
export default function Community() {
  return <PremiumLanding
    testid="community-page"
    badge="YUMO Community"
    title="Food intelligence for the table you share."
    tagline="One shared Taste DNA. Balanced menus everyone loves."
    description="Community blends the taste profiles of your family and friends into a single decision — so hosting stops being a debate and starts being a delight."
    capabilities={[
      { label: "Shared Taste DNA", detail: "Merge 2-8 profiles into a single group brain — automatically balanced across spice, diet, and cuisine." },
      { label: "Balanced Menus", detail: "Get complete meal plans that respect every participant's tastes and restrictions." },
      { label: "Party & Occasion Planning", detail: "From weekend dinners to birthdays — YUMO curates the story of the meal." },
      { label: "Grocery & Ordering", detail: "One tap to convert the menu into a grocery list or delivery cart." },
    ]}
  />;
}
